<template>
    <v-card class="mx-auto" max-width="800">
        <v-data-table 
         :headers="headers"
         :items="vatData"  
         :loading="loading"
         :rows-per-page-items="[6,12,18,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
         no-data-text="Nahrajte aktuální data tlačítkem [STÁHNOUT Z POKLADNY]"
        >
            <template v-slot:items="props">
                <td class="text-xs-left subheading">
                    {{ props.item.id  }}
                </td>
                <td class="text-xs-right subheading">
                    
                    <v-edit-dialog
                    :return-value.sync="props.item.vat_rate"
                    lazy
                    > {{ props.item.vat_rate  }}
                    <template v-slot:input>
                        <v-form @submit.prevent="onSubmit" v-model="valid">
                            <v-text-field
                                v-model.number="props.item.vat_rate"
                                :rules="rules"
                                label="Editace"
                                single-line
                                outline
                            
                            ></v-text-field>    
                        </v-form>
                    </template>
                    
                    </v-edit-dialog>
                </td>
            </template>
            <template v-slot:item.rate="{ item, update }">
                <v-text-field v-model="item.vat_rate" @input="update"></v-text-field>
            </template>
        </v-data-table>
        <v-card-actions >
            <v-layout align-center justify-start>
                <v-btn color="primary" @click="loadData" :disabled="!sdrv">{{ $t('Stáhnout z pokladny') }}</v-btn>
            </v-layout>
            <v-layout align-center justify-end>
                <v-btn color="info" @click="save" :disabled="!sdrv || !valid">{{ $t('Nahrát do pokladny') }}</v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    /*eslint-disable */
    name: 'vat-table',
    props: ['ecr', 'sdrv'],
    data() {
        return {
            headers: [
                { text: 'DPH ID', value: 'id', class:'subheading' },
                { text: 'DPH sazba', value: 'vat_rate', sortable: false, class:'subheading' },
            ],
            vatData: [],
            loading: false,
            valid: false,
            rules: [v => !!v || 'Hodnota je vyžadována', v => !isNaN(v) || "Hodnota musí být číslo"]
        }
    },
    mounted() {
        // this.loadData();
    },
    methods: {
        onSubmit(e) {

        },
        async loadData() {
            try {
                this.$emit('loading', true)
                this.loading = true
                let response = await this.axios.get(`/api/ecr-vattable?ip=${this.ecr.ip_vpn}`)
                console.log(response)
                this.vatData = response.data

            } catch (e) {
                console.log(e)
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
                this.$emit('loading', false)
            }
            
        },
        async save() {
            try {
                this.$emit('loading', true)
                this.loading = true
                this.vatData.map(v => v.vat_rate = parseFloat(v.vat_rate))
                await this.axios.put(`/api/ecr-vattable/?ip=${this.ecr.ip_vpn}`, this.vatData)
            } catch (e) {
                console.log(e)
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
                this.$emit('loading', false)
            }
        },
        max25chars: (v) => v.lenght < 25 
    },
}
</script>
